export const COMPANIES_LIST_FETCH_ALL_LIMIT = "100";
